const modal = document.querySelector('#factsheet-modal');
const toggleButtons = document.querySelectorAll('[data-action="factsheet-modal-toggle"]');

if (modal) {

    // Show the modal when the toggle button is clicked
    if (toggleButtons) {
        toggleButtons.forEach(button => {
            button.addEventListener('click', () => {
                modal.setAttribute('aria-hidden', 'false');
                document.body.classList.add('overflow-hidden');
            });
        });
    }

    // Close the modal when the close button is clicked
    modal.querySelector('.modal__close').addEventListener('click', () => {
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('overflow-hidden');
    });

}